import { Vue, Component, Prop } from 'vue-property-decorator';
import * as mws from '@/shared/MwsViewModels';
import template from './fund-risk-warning-panel.vue';

@Component({
  mixins: [template],
})
export default class FundRiskWarningPanel extends Vue {
  @Prop()
  data: mws.FundRiskWarningPanel;
}
